import widgetsMgr from 'widgets/widgetsMgr';
import KlaviyoEventListener from './widgets/KlaviyoEventListener';
import KlaviyoListeners from './widgets/KlaviyoListeners';

widgetsMgr.addWidgetsList('global.widgets.klaviyo', () => [
    ['KlaviyoEventListener', KlaviyoEventListener],
    ['KlaviyoListeners', KlaviyoListeners]
]);
